export const state = {
  loading: true,
  isOpen: false,
  selectedDocuments: [],
  downloadPending: false,
  downloadError: null,
}
